import { render, staticRenderFns } from "./StatisticsRecruitmentPage.vue?vue&type=template&id=68ee66ef&scoped=true"
import script from "./StatisticsRecruitmentPage.vue?vue&type=script&lang=js"
export * from "./StatisticsRecruitmentPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticsRecruitmentPage.vue?vue&type=style&index=0&id=68ee66ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee66ef",
  null
  
)

export default component.exports